import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { formatUrl } from '../shared/utils/format-url-util';
import { ENDPOINTS } from '../shared/constants/url.constants';
import { HttpRequestService } from '../shared/services/http-request.service';
import { GlobalErrorHandlerService } from '../shared/services/global-error-handler.service';
import { NotificationService } from '../shared/services/notification.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class TimesheetService {
  constructor(
    private httpClient: HttpRequestService,
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService,
    private notificationService: NotificationService
  ) { }

  getTimeoffServiceCodes(
    program_code: string,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_TIME_OFF_SERVICE_CODES, {
      program_code,
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  updateStatusConsumerTimesheet(payload: any, status: string): Observable<any> {
    const statusName = (status === "GP") ? 'Approved' : 'Denied';
    return this.httpClient
      .post(ENDPOINTS.CLAIMS.UPDATE_STATUS_CONSUMER_TIMESHEET, payload, true)
      .pipe(
        tap(() => {
          this.notificationService.success(
            'Success',
            `Timesheet ${statusName} Successfully.`
          );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  saveAdjudicationDetails(payload: any): Observable<any> {
    return this.httpClient
      .post(ENDPOINTS.CLAIMS.SAVE_ADJUDICATIONS, payload, false)
      .pipe(
        tap(() => {
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  getproviderTsDenialReasons(
    programCode: string,
    timesheetdetailID: any,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_TS_DENIAL_REASONS, {
      programCode,
      timesheetdetailID
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  getConsumerList(
    programCode: string,
    providerId: any,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_CONSUMER_LIST, {
      programCode,
      providerId
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }
  getConsumerListByPPLId(
    payload: any,
    isAfterUpdate = false
  ): Observable<any> {
    return this.httpClient
      .post(ENDPOINTS.CLAIMS.GET_CONSUMER_LIST_BY_PPLID, payload, isAfterUpdate)
      .pipe(
        tap(() => {
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  getProviderList(
    programCode: string,
    consumerId: any,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_PROVIDER_LIST, {
      programCode,
      consumerId
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  getPayPeriod(
    programCode: string,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_PAY_PERIOD, {
      programCode
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  getServiceCodes(
    programCode: string,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_TS_SERVICE_CODE, {
      programCode,
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }
  
  getProcessCodes(
    programCode: string,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_TS_PROCESS_CODE, {
      programCode,
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  getServiceCodesByConsumer(
    payload: any,
  ): Observable<any> {
    return this.httpClient.post(ENDPOINTS.CLAIMS.GET_SERVICE_CODE_BY_CONSUMER, payload, true)
      .pipe(
        tap(() => {
          // this.notificationService.success(
          //   'Success',
          //   'Timesheet updated Successfully.'
          // );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  getAuthDetails(
    programCode: string,
    payrollId: any,
    isAfterUpdate = false
  ): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_AUTH_DETAILS, {
      programCode, payrollId
    });
    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  getConsumerTsDetails(
    type: string,
    programCode: string,
    participantId: any,
    providerId: any,
    fromDate: any,
    toDate: any,
    isAfterUpdate = false
  ): Observable<any> {
    const endpoint = (type === 'processed' ? ENDPOINTS.CLAIMS.GET_CONSUMER_PROCESSED_TIMESHEET_DETAILS : ENDPOINTS.CLAIMS.GET_CONSUMER_IP_TIMESHEET_DETAILS)
    const url = formatUrl(endpoint, {
      programCode,
      participantId,
      providerId,
      fromDate,
      toDate
    });

    return this.httpClient.get(url, isAfterUpdate).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  getConsumerPayrollDetails(payload: any): Observable<any> {
    return this.httpClient
      .post(ENDPOINTS.CLAIMS.GET_CONS_TS_DETAILS, payload, true)
      .pipe(
        tap(() => {
          // this.notificationService.success(
          //   'Success',
          //   'Timesheet updated Successfully.'
          // );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  getTimesheet(payload: any): Observable<any> {
    return this.httpClient
      .post(ENDPOINTS.CLAIMS.GET_TIMESHEET, payload, true)
      .pipe(
        tap(() => {
          // this.notificationService.success(
          //   'Success',
          //   'Timesheet updated Successfully.'
          // );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  saveTimesheet(payload: any, action: string): Observable<any> {
    if(payload && payload.serviceLines.length) {
      payload.serviceLines = payload.serviceLines.filter((e: any) => e.selected && e.serviceTimeIn && e.serviceTimeOut);
    }
    const actionPerformed = action.toLowerCase() === 'edit' ? 'updated' : 'added';
    return this.httpClient
      .post(ENDPOINTS.CLAIMS.SAVE_TIMESHEET, payload, true)
      .pipe(
        tap(() => {
          this.notificationService.success(
            'Success',
            `Timesheet ${actionPerformed} successfully.`
          );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  moveBackTimesheet(programCode: string, payload: any): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.MOVEBACK_TIMESHEET, {
      programCode
    });
    return this.httpClient
      .post(url, payload, true)
      .pipe(
        tap(() => {
          this.notificationService.success(
            'Success',
            `Timesheet moved back successfully.`
          );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  deleteTimesheet(programCode: string, timesheetLineDetailid: any): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.DELETE_TIMESHEET, {
      programCode, timesheetLineDetailid
    });
    return this.httpClient
      .post(url, {}, false)
      .pipe(
        tap(() => {
          this.notificationService.success(
            'Success',
            'Timesheet deleted successfully.'
          );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  saveTimeOff(payload: any): Observable<any> {
    return this.httpClient
      .post(ENDPOINTS.CLAIMS.SAVE_TIMEOFF, payload, true)
      .pipe(
        tap(() => {
          this.notificationService.success(
            'Success',
            'Time off added successfully.'
          );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  getProviderTsDetails(payload: any): Observable<any> {
    return this.httpClient
      .post(ENDPOINTS.CLAIMS.GET_PA_TS_DETAILS, payload, true)
      .pipe(
        tap(() => {
          // this.notificationService.success(
          //   'Success',
          //   'Timesheet updated Successfully.'
          // );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  getTimeOffTimesheets(programCode: string, providerID: string): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_VIEW_TIMEOFF, {
      programCode, providerID
    });
    return this.httpClient.get(url).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  getAuthTimesheetUtilization(programCode: string, authId: string, participantId: string): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_AUTH_TS_UTILIZATION, {
      programCode, participantId, authId
    });

    return this.httpClient.get(url).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  getAuthUtilization(programCode: string, participantId: string, authId: string): Observable<any> {
    const url = formatUrl(ENDPOINTS.CLAIMS.GET_AUTH_UTILIZATION, {
      programCode, participantId, authId
    });
    return this.httpClient.get(url).pipe(
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

  updateTimesheetAdjudication(payload: any): Observable<any> {
    return this.httpClient
      .post(ENDPOINTS.CLAIMS.UPDATE_TIMESHEET_ADJ, payload, true)
      .pipe(
        tap(() => {
          this.notificationService.success(
            'Success',
            `Timesheet Adjudicated successfully.`
          );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }

  getPayStub(checkId: string, empId: string) {
    const url = formatUrl(ENDPOINTS.PAY_API.GET_PAYSTUBS, {
      checkId, empId
    });
    const headers = new HttpHeaders({
      'content-type': 'application/json'
    })
    return this.http.get(url, { headers: headers, responseType: 'blob', observe: 'response' });
  }

  denyOverrideTimesheet(endpointUrl: string, programCode: string, payload: any, placeholder : string): Observable<any> {
    const url = formatUrl(endpointUrl, { programCode });

    return this.httpClient
      .post(url, payload, true)
      .pipe(
        tap(() => {
          this.notificationService.success(
            'Success',
            `Timesheet ${placeholder} successfully.`
          );
        }),
        catchError((err) => {
          return throwError(() => this.errorHandler.handleError(err));
        })
      )
  }
}
